const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
}

const layoutWidthTypes = {
  FLUID: "fluid",
  BOXED: "boxed",
  SCROLLABLE: "scrollable",
}

const layoutModeTypes = {
  DARK: "dark",
  LIGHT: "light",
}

const topBarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
}

const leftBarThemeImageTypes = {
  NONE: "none",
  IMG1: "img1",
  IMG2: "img2",
  IMG3: "img3",
  IMG4: "img4",
}

const leftSidebarTypes = {
  // DEFAULT era "icon", igual a ICON: o menu completo não tinha valor próprio.
  // Como o reducer usa DEFAULT de fallback, quem estava sem localStorage (aba
  // anônima, aparelho novo) bootava com o menu recolhido. "default" é o valor
  // que o resto do código (saga, Sidebar) já compara.
  DEFAULT: "default",
  COMPACT: "compact",
  ICON: "icon",
}

const leftSideBarThemeTypes = {
  LIGHT: "light",
  COLORED: "colored",
  DARK: "dark",
  WINTER: "winter",
  LADYLIP: "ladylip",
  PLUMPLATE: "plumplate",
  STRONGBLISS: "strongbliss",
  GREATWHALE: "greatwhale",
}

// Breakpoint ÚNICO do menu lateral. DEVE ser idêntico ao do CSS
// (custom/structure/_vertical.scss) e é complementar ao `d-lg-*` do Bootstrap,
// que vira em min-width: 992px. Abaixo dele o menu é uma GAVETA (250px, sobre o
// conteúdo); acima, é fixo e pode ser recolhido no rail de 70px.
const SIDEBAR_MOBILE_MEDIA_QUERY = "(max-width: 991.98px)"

// Usa o VIEWPORT (a janela real), não `window.screen.width`, que mede o
// DISPOSITIVO e ignora o tamanho da janela — origem do descompasso entre o JS
// (que usava 998/992) e o CSS (992/991.98) que quebrava o menu.
const isMobileViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia(SIDEBAR_MOBILE_MEDIA_QUERY).matches

export {
  layoutTypes,
  layoutModeTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  SIDEBAR_MOBILE_MEDIA_QUERY,
  isMobileViewport,
}
